module.exports = __webpack_public_path__ + "static/media/SubredditTimer.ab3a8b8f.png";